export default __webpack_public_path__ + "static/media/Bild2.d36ccd63.png";